import React, { useEffect, useState } from "react";
import axios from "axios";
// material-ui
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Paper from "@material-ui/core/Paper";
import ButtonBase from "@material-ui/core/ButtonBase";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import Divider from "@material-ui/core/Divider";

import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";

import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

//icons
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import AutorenewIcon from "@material-ui/icons/Autorenew";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import StorageIcon from "@material-ui/icons/Storage";
import LockIcon from "@material-ui/icons/Lock";

// app components
import { usePouchDB } from "../../../components/PouchDB/PouchDBProvider";
import { useDataSync } from "../../../components/PouchDB/DataSyncProvider";
import AppPageLoading from "../../../components/AppPageLoading";
//utils
//import uuidv1 from 'uuid/v1';
// styles
import useStyles from "./styles";

// images
import kb from "../../../images/kb.png";

//utils
import qs from "query-string";
import { Link, useParams } from "react-router-dom";
import { useSnackbar } from "notistack";
import {
  FormControl,
  Select,
  MenuItem,
  CardContent,
  Card,
  Box,
} from "@material-ui/core";
import { Alert } from "reactstrap";
import { countAge } from "../forms/pk/validation";

function Home({ history, match, location }) {
  const USER_KEY_PG = process.env.REACT_APP_USER_KEY_PROXY_GATEWAY;
  const NEW_URL = process.env.REACT_APP_API_CONFIG_URL_NEW;
  const db_name = localStorage.getItem("db_name");
  const remote_base = localStorage.getItem("remote_base");
  const url = remote_base + "/" + db_name;
  const url_split = remote_base ? remote_base.split("/") : "";
  const couchdb = url_split[url_split.length - 1];

  const classes = useStyles();
  const {
    user: { metadata },
    dataKK,
    dataKB,
    dataPK,
    dataBkkbn,
  } = usePouchDB();
  const { manualSync, isManualSyncing } = useDataSync();
  const [dataBkkbnDocs, setDataBkkbnDocs] = useState([]);
  const [isFetching, setFetching] = useState(true);
  const [isDeleting, setDeleting] = useState(false);
  const [kepalaKels, setKepalaKels] = useState([]);
  const [status, setStatus] = useState([]);
  const { enqueueSnackbar } = useSnackbar();

  const [filterRwRt, setFilterRwRt] = useState("");
  const [didCancel, setDidCancel] = useState(false);

  const [statusSensus, setStatusSensus] = useState("All");
  const [statusNik, setStatusNik] = useState("");
  const [filterProbability, setFilterProbability] = useState([]);

  const [rw, setRw] = useState("");
  const [rt, setRt] = useState("");
  const [nik999, setNik999] = useState("");
  const [renew, setRenew] = useState(false);
  const [dataBkkbnDocsRenew, setDataBkkbnDocsRenew] = useState([]);
  const [totalData, setTotalData] = useState(0);
  const [dataLokal, setDataLokal] = useState("");
  const [dataServer, setDataServer] = useState("");
  const [visible, setVisible] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [forDelete, setDelete] = useState("");

  const [opr, setOpr] = useState(localStorage.getItem("opr"));
  const [localRw, setLocalRw] = useState(localStorage.getItem("rw"));

  const [lock, setLock] = useState(localStorage.getItem("lock"));
  const [lockWilayah, setLockWilayah] = useState(
    localStorage.getItem("lockWilayah")
  );
  const [lockTarget, setLockTarget] = useState(
    localStorage.getItem("lockTarget")
  );

  const [expanded, setExpanded] = React.useState(false);

  const [dataRedudan, setDataRedudan] = useState([]);

  const [openLock, setOpenLock] = React.useState(false);
  const [isOpenAlert, setIsOpenAlert] = useState(false);
  const [isOpenAlertCadangan, setIsOpenAlertCadangan] = useState(false);
  const [noUrutBelumMutakhir, setNoUrutBelumMutakhir] = useState(0);
  const [openTotalTarget, setOpenTotalTarget] = React.useState(false);

  const [targetkk, setTragetKK] = useState(0);
  const [totalDataKKAll, setTotalDataKKAll] = useState(0);

  const [jumlahKeluargaUtama, setJumlahKeluargaUtama] = useState(0);
  const [jumlahKeluargaCadangan, setJumlahKeluargaCadangan] = useState(0);
  const [initialDataFilter, setInitialDataFilter] = useState([]);

  const [stsKeluarga, setStsKeluarga] = useState([
    { value: "1", label: "Ada" },
    { value: "2", label: "Pindah" },
    { value: "3", label: "Seluruh Anggota Meninggal Dunia" },
    { value: "4", label: "Tidak Ditemukan" },
    { value: "5", label: "Keluarga Baru" },
  ]);

  const labelOptionNIK = "NIK tidak Wajar";

  useEffect(() => {
    const getAllDataKK = async () => {
      let total = 0;
      let target_kk = 0;
      let selector = {
        user_name: { $eq: metadata.nameProses },
        periode_sensus: { $eq: "2025" },
        status_sensus: { $ne: "Delete" },
        status_draft: { $ne: "1" },
      };

      if (opr === "true" && localRw !== "false") {
        selector = {
          user_name: { $eq: metadata.nameProses },
          id_rw: { $eq: localRw },
          periode_sensus: { $eq: "2025" },
          status_sensus: { $ne: "Delete" },
          status_draft: { $ne: "1" },
        };
      }

      try {
        const query = await dataBkkbn.local.find({
          selector,
        });

        let all = [];

        query.docs.forEach((item) => {
          if (item.status_sensus !== "Delete") {
            if (
              item.status_sensus === "Received" ||
              item.status_sensus === "Valid" ||
              item.status_sensus === "Anomali" ||
              item.status_sensus === "Anomali Terkonfirmasi" ||
              item.status_sensus === "NotValid"
            ) {
              if (item.sts_keluarga === "1" || item.sts_keluarga === "5") {
                all.push(item);
              }
            }
          }
        });
        total = all.length;
      } catch (error) {}

      if (metadata.wil_rw.length > 0) {
        let rwName = [];
        let rtName = [];
        if (opr === "true" && localRw !== "false") {
          metadata.wil_rw.forEach((rw) => {
            rwName.push(rw.nama_rw);
            if (rw.wil_rt.length > 0) {
              if (parseInt(rw.id_rw) === parseInt(localRw)) {
                rw.wil_rt.forEach((rt) => {
                  rtName.push(rt.nama_rt);
                  //)
                  let targetRT = rt.targetkk;
                  if (String(rt.targetkk) === "null") {
                    //
                    targetRT = 0;
                  }

                  target_kk = target_kk + parseInt(targetRT);
                });
              }
            }
          });
        } else {
          metadata.wil_rw.forEach((rw) => {
            rwName.push(rw.nama_rw);
            if (rw.wil_rt.length > 0) {
              rw.wil_rt.forEach((rt) => {
                rtName.push(rt.nama_rt);
                //)
                let targetRT = rt.targetkk;
                if (String(rt.targetkk) === "null") {
                  //
                  targetRT = 0;
                }

                target_kk = target_kk + parseInt(targetRT);
              });
            }
          });
        }
      }
      //
      //

      setTotalDataKKAll(total);
      setTragetKK(target_kk);
    };
    getAllDataKK();
  }, []);

  const params = useParams();

  const findDuplicates = (arr) => {
    const nikMap = new Map();
    let duplicates = [];

    arr.forEach((item) => {
      const nik = item.data_nik[0]?.nik;
      if (nik) {
        if (nikMap.has(nik)) {
          nikMap.get(nik).push(item);
        } else {
          nikMap.set(nik, [item]);
        }
      }
    });

    nikMap.forEach((items) => {
      if (items.length > 1) {
        duplicates.push(...items);
      }
    });
    duplicates.sort((a, b) => a.data_nik[0].nik - b.data_nik[0].nik);
    return duplicates;
  };

  const getAllDataBkkbn = async () => {
    setFetching(true);
    try {
      let selector = {
        user_name: { $eq: metadata.nameProses },
        // periode_sensus: { $eq: "2024" },
        status_sensus: { $ne: "Delete" },
        status_draft: { $ne: "1" },
      };

      if (opr === "true" && localRw !== "false") {
        selector = {
          user_name: { $eq: metadata.nameProses },
          id_rw: { $eq: localRw },
          // periode_sensus: { $eq: "2024" },
          status_sensus: { $ne: "Delete" },
          status_draft: { $ne: "1" },
        };
      }

      const query = await dataBkkbn.local.find({
        selector,
      });

      const newDocs = [];
      const newDocsRenew = [];
      query.docs.reverse().forEach((item) => {
        // console.log("ambil semua data", item);

        if (item.status_sensus !== "Delete") {
          if (item.status_draft === "2") {
            newDocs.push(item);
          }
        }
      });
      // console.log(
      //   newDocs.filter((el) => el.data_nik[0].nik === "1101112204930001")
      // );
      const last = findDuplicates(newDocs);
      const redudan = [];
      for (let i = 0; i < last.length; i++) {
        const data = last[i];
        redudan.push({
          ...data.data_nik[0],
          _id: data._id,
          status_sensus: data.status_sensus,
          no_rmh: data.no_rmh,
          no_urutkel: data.no_urutkel,
          year_doc: data.year_doc,
          sts_keluarga: data.sts_keluarga,
          cfm: data.cfm,
        });
      }

      let sts10;
      // Looping dan filter data_nik dengan nilai '9999999999999999'
      for (let index = 0; index < newDocs.length; index++) {
        let sts9 = newDocs[index].data_nik.find(
          (elnik) =>
            elnik.nik &&
            (elnik.nik.substring(0, 5) === "12345" ||
              elnik.nik.substring(0, 5) === "00000" ||
              elnik.nik.substring(11, 16) === "00000" ||
              elnik.nik.substring(0, 6) === "010101" ||
              elnik.nik.substring(0, 6) === "030303" ||
              elnik.nik.substring(0, 6) === "090909" ||
              elnik.nik.substring(11, 16) === "66666" ||
              elnik.nik.substring(11, 16) === "88888" ||
              elnik.nik.substring(11, 16) === "55555" ||
              elnik.nik.substring(11, 16) === "11111" ||
              ((elnik.nik.substring(0, 5) === "99999" ||
                elnik.nik.substring(11, 16) === "99999") &&
                elnik.nik !== "9999999999999999") ||
              elnik.nik === "0000000000000000" ||
              elnik.nik === "1111111111111111" ||
              elnik.nik === "2222222222222222" ||
              elnik.nik === "3333333333333333" ||
              elnik.nik === "4444444444444444" ||
              elnik.nik === "5555555555555555" ||
              elnik.nik === "6666666666666666" ||
              elnik.nik === "7777777777777777" ||
              elnik.nik === "8888888888888888" ||
              (elnik.nik === "9999999999999999" &&
                countAge(elnik.tgl_lahir) >= 17) ||
              elnik.nik === "1901089999999999")
        );

        sts10 = newDocs[index].data_nik.find(
          (elnik) => elnik.nik === "9999999999999999"
        );
        newDocs[index].niktidakwajar = !!sts9;
        newDocs[index].niktidakwajar99 = !!sts10;
      }

      if (!didCancel) {
        // if (statusNik === "ya") {
        //   const filteredDocs = newDocs.filter(
        //     (doc) => doc.niktidakwajar === true
        //   );
        //   setDataBkkbnDocs(filteredDocs);
        // } else if (statusNik === "tidak") {
        //   const filteredDocs = newDocs.filter(
        //     (doc) => doc.niktidakwajar99 === true
        //   );
        //   setDataBkkbnDocs(sts10);
        // } else {
        //   setDataBkkbnDocs(newDocs);
        // }
        console.log(newDocs.length);

        if (statusNik === "") {
          setDataBkkbnDocs(newDocs);
        }
        setDataBkkbnDocsRenew(newDocsRenew);
        setDataLokal(newDocs.length);
        setDataRedudan(redudan);
      }
    } catch (e) {
      // Handle error
      console.log("error: ", e);
    }

    if (!didCancel) {
      setFetching(false);
    }
  };

  const getAllDataBkkbnServer = async () => {
    setFetching(true);
    try {
      const savedServerCount = localStorage.getItem("dataServerCount");

      if (savedServerCount) {
        // console.log(
        //   "Menggunakan nilai dataServerCount dari localStorage:",
        //   savedServerCount
        // );
        // console.log(savedServerCount, "<< cek 2");

        setDataServer(parseInt(savedServerCount));
      } else {
        // let selector = {
        //   user_name: { $eq: metadata.name },
        //   // periode_sensus: { $eq: "2024" },
        //   // status_sensus: { $ne: "Delete" },
        //   // status_draft: { $ne: "1" },
        // };

        // if (opr === "true" && localRw !== "false") {
        //   selector = {
        //     user_name: { $eq: metadata.name },
        //     id_rw: { $eq: localRw },
        //     // periode_sensus: { $eq: "2024" },
        //     // status_sensus: { $ne: "Delete" },
        //     // status_draft: { $ne: "1" },
        //   };
        // }

        // const query = await dataBkkbn.remote.find({
        //     selector,
        //     limit: 10000
        // });

        // const data_selector = {
        //   selector: selector,
        //   limit: 10000,
        // };

        // console.log(data_selector, "Data Selector INDEX");

        const idkec = metadata?.wil_kecamatan?.id_kecamatan;

        // const res = await axios.post(
        //   url +
        //     "/_find?couchdb=" +
        //     couchdb +
        //     "&database-name=" +
        //     db_name +
        //     "&idKec=" +
        //     idkec,
        //   data_selector,
        //   {
        //     // headers: { user_key: USER_KEY_PG }
        //     headers: { Authorization: "Basic YWRtaW46cGFzc3dvcmQ=" },
        //   }
        // );
        const url_GetPk = NEW_URL + "pk/api/v1/getPk";
        // console.log("url_GetPk >>> ", url_GetPk);

        const requestBody = {
          username: metadata.nameProses,
        };
        const res = await axios.post(url_GetPk, requestBody);
        const { data } = await res;
        // console.log("Data BKKBN Server from list:", data);

        const query = { docs: data };

        const newDocs = [];
        query.docs.reverse().forEach((item) => {
          if (item.status_sensus !== "Delete") {
            if (item.status_draft === "2") {
              newDocs.push(item);
            }
          }
        });

        if (!didCancel) {
          // console.log(newDocs.lenght, "<< cek 3");

          setDataServer(newDocs.length);
        }
      }
    } catch (error) {
      console.error("Error getting server data:", error);
    }

    if (!didCancel) {
      setFetching(false);
    }
  };

  useEffect(() => {
    const item = localStorage.getItem("forceRefreshData");
    //
    if (item === "true") {
      // , 'dataBkkbn change')
      getAllDataBkkbn();
      getAllDataBkkbnServer();

      localStorage.setItem("forceRefreshData", "false");
    }
  }, [isManualSyncing]);

  useEffect(() => {
    getAllDataBkkbn();
    getAllDataBkkbnServer();

    return () => {
      setDidCancel(true);
    };
  }, []);

  // useEffect(() => {
  //   console.log("berubah", kepalaKels);
  // }, [kepalaKels]);

  function parseDate(dateStr) {
    // Pisahkan string berdasarkan '-' dan buat objek Date
    const [day, month, year] = dateStr.split("-").map(Number);
    return new Date(year, month - 1, day); // Bulan dimulai dari 0 di JavaScript
  }

  function calculateAge(tanggalLahir) {
    // Parsing tanggal lahir dengan format DD-MM-YYYY
    const birthDate = parseDate(tanggalLahir);

    // Validasi tanggal lahir
    if (isNaN(birthDate.getTime())) {
      console.error("Invalid birth date");
      return;
    }

    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();

    if (
      monthDifference < 0 ||
      (monthDifference === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }

    return age;
  }

  useEffect(() => {
    const queryParams = qs.parse(location.search);
    // console.log("data bkkbn>>>>", dataBkkbnDocs);

    let kepalas = dataBkkbnDocs
      .filter((kkDoc) => typeof kkDoc.data_nik !== "undefined")
      .map((kkDoc) => {
        let findKepala = kkDoc.data_nik.find(
          (data_nik) => data_nik.sts_hubungan
        );
        if (!findKepala) {
          findKepala = kkDoc.data_nik[0];
        }

        // Inisialisasi variabel niknormal
        let niknormal = true;

        // Looping untuk mengecek NIK dan umur
        kkDoc.data_nik.some((nikItem) => {
          if (nikItem.nik === "9999999999999999") {
            const umur = calculateAge(nikItem.tgl_lahir); // Hitung umur dari tanggal lahir
            if (umur > 17) {
              niknormal = false; // NIK dianggap tidak normal jika umur lebih dari 17
            } else {
              niknormal = true; // Jika umur <= 17, maka NIK dianggap normal
            }
            return true; // Berhenti iterasi setelah validasi pertama
          }
        });

        return {
          ...findKepala,
          status_sensus: kkDoc.status_sensus,
          data_nik: kkDoc.data_nik,
          _id: kkDoc._id,
          no_rmh: kkDoc.no_rmh,
          no_urutkel: kkDoc.no_urutkel,
          year_doc: kkDoc.year_doc,
          sts_keluarga: kkDoc.sts_keluarga,
          niknormal: niknormal, // tambahkan properti niknormal
          flag_retrieve: kkDoc.flag_retrieve,
          cfm: kkDoc.cfm,
        };
      });

    // console.log("Data Kepala Keluarga:", kepalas);

    //

    setStatus(status);

    if (queryParams.query) {
      kepalas = kepalas.filter((kepala) => {
        if (kepala.nama_anggotakel !== undefined) {
          return kepala.nama_anggotakel
            .toLowerCase()
            .includes(queryParams.query.toLowerCase());
        }
      });
    }

    // setKepalaKels(kepalas);
    let dataRetrievePkJson = localStorage.getItem("retrievePk");
    let dataRetrievePk = JSON.parse(dataRetrievePkJson);
    // console.log("Data Retrieve PK:", dataRetrievePk);

    if (dataRetrievePk) {
      dataRetrievePk = dataRetrievePk.map((data) => {
        data["nama_anggotakel"] = data.data_nik[0].nama_anggotakel;
        data["nik"] = data.data_nik[0].nik;
        return data;
      });
      // console.log(kepalas.concat(dataRetrievePk).length, "<< cek 1");

      // setDataServer(kepalas.concat(dataRetrievePk).length);

      setKepalaKels(kepalas.concat(dataRetrievePk));
    } else {
      setKepalaKels(kepalas);
    }

    const countUtama = kepalas.filter(
      (kepala) =>
        kepala.flag_retrieve && kepala.flag_retrieve.toLowerCase() === "utama"
    ).length;

    const countCadangan = kepalas.filter(
      (kepala) =>
        kepala.flag_retrieve &&
        kepala.flag_retrieve.toLowerCase() === "cadangan"
    ).length;

    const dataCadangan = kepalas.filter(
      (kepala) =>
        kepala.flag_retrieve &&
        kepala.flag_retrieve.toLowerCase() === "cadangan"
    );

    // console.log("Jumlah Keluarga Utama:", dataCadangan);

    const cadanganNumber = kepalas.map((kepala) => {
      if (
        kepala.flag_retrieve &&
        kepala.flag_retrieve.toLowerCase() === "cadangan"
      ) {
        const indexCadangan = dataCadangan.findIndex(
          (item) => item._id === kepala._id
        );
        // console.log("nomor urut", indexCadangan);
        return {
          ...kepala,
          nomor_urut_cadangan: indexCadangan + 1,
        };
      }
      return kepala;
    });

    // console.log(
    //   "Data Kepala Keluarga dengan nomor urut cadangan:",
    //   cadanganNumber
    // );

    // console.log("Jumlah Keluarga Utama:", countUtama);
    // console.log("Jumlah Keluarga Cadangan:", countCadangan);
    setJumlahKeluargaUtama(countUtama);
    setJumlahKeluargaCadangan(countCadangan);
    setKepalaKels(cadanganNumber);
    // console.log("Data Kepala Keluarga setelah filter:", kepalas);
  }, [dataBkkbnDocs, location.search]);

  useEffect(() => {
    setTotalData(kepalaKels.length);
    // console.log("Total Kepala Keluarga:", kepalaKels);
  }, [kepalaKels]);

  useEffect(() => {
    // if (dataServer !== '' && dataLokal !== '') {
    //     if (dataLokal !== dataServer) {
    setVisible(true);
    //     }
    // }
  }, [dataLokal, dataServer]);

  const updateNotif = (id) => {
    let userUpdate = metadata.nameProses;
    let userDataUpdate = 8;
    // fetch('https://demo-bkkbn-notif.herokuapp.com/api/v1/pushnotification', {
    // fetch('http://web-push-notification-service-bkkbn.apps.tkp.platform.lintasarta.net/api/v1/pushnotification', {

    fetch("https://webpushnotif-dev.bkkbn.go.id/api/v1/pushnotification", {
      // fetch('https://webpushnotif.bkkbn.go.id/api/v1/pushnotification', {
      // fetch('http://dev-web-push-notification-service-bkkbn.apps.tkp.platform.lintasarta.net/api/v1/pushnotification', {
      method: "POST",
      headers: { "Content-type": "application/json" },
      body: JSON.stringify({
        _id: id,
        username: userUpdate,
        statusData: userDataUpdate,
      }),
    })
      .then((respone) => {
        respone.json();
      })
      .then((data) => {})
      .catch((e) => console.error(e));
  };

  // const updateKel = (_id) => async (e) => {
  //   setFetching(true);
  //   try {
  //     let kkDocRemote;
  //     let dataToLocal;
  //     let dataToSave;
  //     let _rev;
  //     const kkDoc = await dataBkkbn.local.get(_id);

  //     let os = window.navigator.userAgent; //get Browser and Os Version
  //     let time = new Date()
  //       .toLocaleString()
  //       .replace(",", "")
  //       .replace(/:.. /, " ");
  //     const audit_trail = "Resend From " + os + " At " + time;
  //     const idkec = metadata?.wil_kecamatan?.id_kecamatan;

  //     try {
  //       // kkDocRemote = await dataBkkbn.remote.get(_id);
  //       const data_selector = {
  //         selector: {
  //           _id: _id,
  //         },
  //         limit: 10000,
  //       };

  //       // console.log(data_selector, "Data Selector INDEX 1");

  //       kkDocRemote = await axios.post(
  //         url +
  //           "/_find?couchdb=" +
  //           couchdb +
  //           "&database-name=" +
  //           db_name +
  //           "&idKec=" +
  //           idkec,
  //         data_selector,
  //         {
  //           // headers: { user_key: USER_KEY_PG }
  //           headers: { Authorization: "Basic YWRtaW46cGFzc3dvcmQ=" },
  //         }
  //       );

  //       if (kkDocRemote.status_sensus == "") {
  //         dataToLocal = {
  //           ...kkDoc,
  //           group: "dataBkkbn",
  //           audit_trail,
  //           status_sensus: "Tersimpan",
  //         };
  //       } else {
  //         if (kkDocRemote.status_sensus == "Delete") {
  //           dataToLocal = {
  //             ...kkDoc,
  //             group: "dataBkkbn",
  //             audit_trail,
  //             status_sensus: "Tersimpan",
  //           };

  //           try {
  //             dataToSave = {
  //               ...kkDocRemote,
  //               audit_trail,
  //               group: "dataBkkbn",
  //               status_sensus: "",
  //             };

  //             // await dataBkkbn['remote'].put(dataToSave);
  //             await axios.put(
  //               url +
  //                 "/" +
  //                 dataToSave._id +
  //                 "/_put?couchdb=" +
  //                 couchdb +
  //                 "&database-name=" +
  //                 db_name +
  //                 "&_id=" +
  //                 dataToSave._id +
  //                 "&idKec=" +
  //                 metadata?.wil_kecamatan?.id_kecamatan,
  //               dataToSave,
  //               {
  //                 // headers: { user_key: USER_KEY_PG }
  //                 headers: { Authorization: "Basic YWRtaW46cGFzc3dvcmQ=" },
  //               }
  //             );
  //           } catch (error) {}
  //         } else {
  //           dataToLocal = {
  //             ...kkDoc,
  //             audit_trail,
  //             group: "dataBkkbn",
  //             status_sensus: kkDocRemote.status_sensus,
  //           };
  //         }
  //       }

  //       await dataBkkbn["local"].put(dataToLocal);
  //     } catch (error) {
  //       try {
  //         dataToSave = {
  //           ...kkDoc,
  //           audit_trail,
  //           group: "dataBkkbn",
  //           status_sensus: "",
  //           _rev,
  //         };

  //         dataToLocal = {
  //           ...kkDoc,
  //           audit_trail,
  //           group: "dataBkkbn",
  //           status_sensus: "Tersimpan",
  //         };

  //         // await dataBkkbn['remote'].put(dataToSave);
  //         await axios.put(
  //           url +
  //             "/" +
  //             dataToSave._id +
  //             "/_put?couchdb=" +
  //             couchdb +
  //             "&database-name=" +
  //             db_name +
  //             "&_id=" +
  //             dataToSave._id +
  //             "&idKec=" +
  //             metadata?.wil_kecamatan?.id_kecamatan,
  //           dataToSave,
  //           {
  //             // headers: { user_key: USER_KEY_PG }
  //             headers: { Authorization: "Basic YWRtaW46cGFzc3dvcmQ=" },
  //           }
  //         );
  //         await dataBkkbn["local"].put(dataToLocal);
  //       } catch (error) {
  //         dataToLocal = {
  //           ...kkDoc,
  //           audit_trail,
  //           group: "dataBkkbn",
  //           status_sensus: "",
  //         };

  //         await dataBkkbn["local"].put(dataToLocal);
  //       }
  //     }

  //     //updateNotif(_id);

  //     enqueueSnackbar("Berhasil refresh data", { variant: "success" });

  //     setTimeout(() => {
  //       getAllDataBkkbn();
  //       getAllDataBkkbnServer();
  //     }, 4000);
  //   } catch (e) {
  //     enqueueSnackbar("Gagal refresh data : " + e.message, {
  //       variant: "error",
  //     });
  //   }
  // };

  const renewKel = async (e) => {
    if (!renew) {
      //setFetching(true)
      //enqueueSnackbar("Data tidak ditemukan", { variant: "error" })
      manualSync();

      setTimeout(() => {
        getAllDataBkkbn();
      }, 4000);
    } else {
      setFetching(true);
      try {
        for (let i = 0; i < dataBkkbnDocsRenew.length; i++) {
          let dataToSave;
          let dataToLocal;
          let _rev;
          if (dataBkkbnDocsRenew[i].status_sensus == "") {
            try {
              // const kkDocRemote = await dataBkkbn.remote.get(dataBkkbnDocsRenew[i]._id);
              const data_selector = {
                selector: {
                  _id: dataBkkbnDocsRenew[i]._id,
                },
                limit: 10000,
              };
              console.log(data_selector, "Data Selector INDEX 2");

              const kkDocRemote = await axios.post(
                url + "/_find?couchdb=" + couchdb + "&database-name=" + db_name,
                data_selector,
                {
                  // headers: { user_key: USER_KEY_PG }
                  headers: { Authorization: "Basic YWRtaW46cGFzc3dvcmQ=" },
                }
              );

              if (kkDocRemote.status_sensus == "") {
                dataToLocal = {
                  ...dataBkkbnDocsRenew[i],
                  group: "dataBkkbn",
                  status_sensus: "Tersimpan",
                };
              } else {
                dataToLocal = {
                  ...dataBkkbnDocsRenew[i],
                  group: "dataBkkbn",
                  status_sensus: kkDocRemote.status_sensus,
                };
              }

              await dataBkkbn["local"].put(dataToLocal);
            } catch (error) {
              try {
                dataToSave = {
                  ...dataBkkbnDocsRenew[i],
                  group: "dataBkkbn",
                  status_sensus: "",
                  _rev,
                };

                dataToLocal = {
                  ...dataBkkbnDocsRenew[i],
                  group: "dataBkkbn",
                  status_sensus: "Tersimpan",
                };

                // await dataBkkbn['remote'].put(dataToSave);
                await axios.put(
                  url +
                    "/" +
                    dataToSave._id +
                    "/_put?couchdb=" +
                    couchdb +
                    "&database-name=" +
                    db_name +
                    "&_id=" +
                    dataToSave._id +
                    "&idKec=" +
                    metadata?.wil_kecamatan?.id_kecamatan,
                  dataToSave,
                  {
                    // headers: { user_key: USER_KEY_PG }
                    headers: { Authorization: "Basic YWRtaW46cGFzc3dvcmQ=" },
                  }
                );
                await dataBkkbn["local"].put(dataToLocal);
              } catch (error) {
                dataToLocal = {
                  ...dataBkkbnDocsRenew[i],
                  group: "dataBkkbn",
                  status_sensus: "",
                };

                await dataBkkbn["local"].put(dataToLocal);
              }
            }
          }
        }

        //manualSync()
        enqueueSnackbar("Berhasil refresh data", { variant: "success" });

        setTimeout(() => {
          getAllDataBkkbn();
        }, 4000);
      } catch (e) {
        //enqueueSnackbar("Gagal refresh data : " + e.message + ", Silahkan coba melakukan refresh page", { variant: "error" })
        enqueueSnackbar("Silahkan coba melakukan refresh page", {
          variant: "success",
        });
      }
    }
  };

  const deleteAll = async (e) => {
    var alert = window.confirm(
      "Apakah anda yakin untuk menghapus semua data ?"
    );
    if (alert) {
      setFetching(true);
      try {
        for (let i = 0; i < dataBkkbnDocs.length; i++) {
          await dataBkkbn.local.put({ ...dataBkkbnDocs[i], _deleted: true });
        }

        enqueueSnackbar("Berhasil hapus data", { variant: "success" });

        setTimeout(() => {
          window.location.reload();
        }, 4000);
      } catch (e) {
        enqueueSnackbar("Gagal hapus data : " + e.message, {
          variant: "error",
        });
      }
    } else {
      enqueueSnackbar("Hapus semua data dibatalkan", { variant: "error" });
    }
  };

  const deleteKel = (_id) => async (e) => {
    // if (!window.confirm("Kamu yakin ingin menghapus data ini?")) {
    //     return false
    // }
    //
    setDeleting(true);
    setDelete("");
    setOpen(false);

    try {
      //remove from local
      const kkDoc = await dataBkkbn.local.get(_id);
      //
      // console.log("tes");
      // if (kkDoc) {
      //   console.log(kkDoc, "KK Doc");
      // }

      await axios
        .post(
          NEW_URL +
            "pk/api/v1/getPkByIdfrm?idfrm=" +
            kkDoc._id +
            "&username=" +
            kkDoc.user_name,
          {},
          { headers: { Authorization: "Basic YWRtaW46cGFzc3dvcmQ=" } }
        )
        .then(async (res) => {
          // console.log("aaaaaaaaaaaaaaaaa", res.data);
          let os = window.navigator.userAgent;
          let time = new Date()
            .toLocaleString()
            .replace(",", "")
            .replace(/:.. /, " ");
          const deleteData = {
            ...res.data.data[0],
            status_sensus: "Delete",
            audit_trail: "Delete From " + os + " At " + time,
          };
          // console.log("Data yang akan dihapus:", deleteData);

          try {
            await axios.post(NEW_URL + "pk/api/v1/save", deleteData, {
              headers: { Authorization: "Basic YWRtaW46cGFzc3dvcmQ=" },
            });
            // .then((res) => console.log("data deleted", res.data));
          } catch (error) {
            console.error("Error saat menghapus data:", error);
          }
        })
        .catch((error) => console.log("Error:", error));

      let os = window.navigator.userAgent; //get Browser and Os Version
      let time = new Date()
        .toLocaleString()
        .replace(",", "")
        .replace(/:.. /, " ");
      const audit_trail = "Delete From " + os + " At " + time;
      const idkec = metadata?.wil_kecamatan?.id_kecamatan;
      // console.log(os, "OS");

      let dataLocal = {
        ...kkDoc,
        audit_trail,
        group: "dataBkkbn",
        status_sensus: "Delete",
      };
      // console.log("Data untuk dihapus lokal:", dataLocal);

      let status = false;
      try {
        // const kkDocRemote = await dataBkkbn.remote.get(_id);
        const data_selector = {
          selector: {
            _id: _id,
          },
          limit: 10000,
        };
        // console.log(data_selector, "Data Selector INDEX 3");
        // console.log("tess");

        // const kkDocRemote = await axios.post(
        //   url +
        //     "/_find?couchdb=" +
        //     couchdb +
        //     "&database-name=" +
        //     db_name +
        //     "&idKec=" +
        //     idkec,
        //   data_selector,
        //   {
        //     // headers: { user_key: USER_KEY_PG }
        //     headers: { Authorization: "Basic YWRtaW46cGFzc3dvcmQ=" },
        //   }
        // );

        // const new_doc = kkDocRemote.data[0];

        // let data = {
        //   ...new_doc,
        //   audit_trail,
        //   group: "dataBkkbn",
        //   status_sensus: "Delete",
        // };

        // await dataBkkbn['remote'].put(data);

        // await axios.post(
        //   url +
        //     "/" +
        //     _id +
        //     "/_delete?couchdb=" +
        //     couchdb +
        //     "&database-name=" +
        //     db_name +
        //     "&_id=" +
        //     _id +
        //     "&idKec=" +
        //     metadata?.wil_kecamatan?.id_kecamatan,
        //   data,
        //   {
        //     // headers: { user_key: USER_KEY_PG }
        //     headers: { Authorization: "Basic YWRtaW46cGFzc3dvcmQ=" },
        //   }
        // );
        // await axios.post(
        //   NEW_URL +
        //     "/" +
        //     _id +
        //     "/_delete?couchdb=" +
        //     couchdb +
        //     "&database-name=" +
        //     db_name +
        //     "&_id=" +
        //     _id +
        //     "&idKec=" +
        //     metadata?.wil_kecamatan?.id_kecamatan,
        //   data,
        //   {
        //     // headers: { user_key: USER_KEY_PG }
        //     headers: { Authorization: "Basic YWRtaW46cGFzc3dvcmQ=" },
        //   }
        // );
        await dataBkkbn["local"].put(dataLocal);

        status = true;
      } catch (error) {
        // console.error("Error saat menghapus data:", error);

        if (error.message == "deleted") {
          await dataBkkbn["local"].put(dataLocal);
          status = true;
        }

        //await dataBkkbn.local.put({ ...kkDoc, _deleted: true });
      }

      if (status) {
        // const kbQuery = await dataBkkbn.local.find({
        //     selector: {
        //         _id: { $eq: _id }
        //     }
        // })
        // if (kbQuery.docs.length > 0)
        //     await dataBkkbn.local.bulkDocs(kbQuery.docs.map(doc => ({ ...doc, _deleted: true })))

        // const pkQuery = await dataBkkbn.local.find({
        //     selector: {
        //         _id: { $eq: _id }
        //     }
        // })
        // if (pkQuery.docs.length > 0)
        //     await dataBkkbn.local.bulkDocs(pkQuery.docs.map(doc => ({ ...doc, _deleted: true })))

        enqueueSnackbar("Data berhasil dihapus", { variant: "success" });

        // getAllDataBkkbn();
        // getAllDataBkkbnServer();

        let id = _id;

        let userDelete = metadata.nameProses;
        let userDataDelete = 9;

        // fetch("https://webpushnotif-dev.bkkbn.go.id/api/v1/pushnotification", {
        //   // fetch('https://webpushnotif.bkkbn.go.id/api/v1/pushnotification', {
        //   // fetch('http://dev-web-push-notification-service-bkkbn.apps.tkp.platform.lintasarta.net/api/v1/pushnotification', {
        //   method: "POST",
        //   headers: { "Content-type": "application/json" },
        //   body: JSON.stringify({
        //     _id: id,
        //     username: userDelete,
        //     statusData: userDataDelete,
        //   }),
        // })
        //   .then((respone) => {
        //     respone.json();
        //   })
        //   .then((data) => {})
        //   .catch((e) => console.error(e));

        setTimeout(() => {
          window.location.reload();
        }, 3500);
      } else {
        enqueueSnackbar("Gagal menghapus data", { variant: "error" });
      }
    } catch (e) {
      enqueueSnackbar("Gagal menghapus data: " + e.message, {
        variant: "error",
      });
    }
    setDeleting(false);
  };

  // useEffect(() => {
  //   if (kepalaKels && kepalaKels.length > 0) {
  //     setInitialDataFilter(kepalaKels);
  //   }
  // }, []);
  const initialData = kepalaKels.slice();

  // useEffect(() => {
  //   console.log("Initial Data Filter:", initialData);
  // }, [initialData]);

  useEffect(() => {
    getSearch(rw, rt, statusSensus, nik999, statusNik, filterProbability);
    // console.log("status nik: ", statusNik);
  }, [rw, rt, statusSensus, statusNik, filterProbability]);

  // useEffect(() => {
  //   if (statusNik === "ya") {
  //     setKepalaKels(
  //       kepalaKels.filter((el) =>
  //         el.data_nik.find(
  //           (elnik) =>
  //             elnik.nik.substring(0, 5) === "12345" ||
  //             elnik.nik.substring(0, 5) === "00000" ||
  //             elnik.nik.substring(11, 16) === "00000" ||
  //             elnik.nik.substring(0, 6) === "010101" ||
  //             elnik.nik.substring(0, 6) === "030303" ||
  //             elnik.nik.substring(0, 6) === "090909" ||
  //             elnik.nik.substring(11, 16) === "66666" ||
  //             elnik.nik.substring(11, 16) === "88888" ||
  //             elnik.nik.substring(11, 16) === "55555" ||
  //             elnik.nik.substring(11, 16) === "11111" ||
  //             ((elnik.nik.substring(0, 5) === "99999" ||
  //               elnik.nik.substring(11, 16) === "99999") &&
  //               elnik.nik !== "9999999999999999") ||
  //             elnik.nik === "0000000000000000" ||
  //             elnik.nik === "1111111111111111" ||
  //             elnik.nik === "2222222222222222" ||
  //             elnik.nik === "3333333333333333" ||
  //             elnik.nik === "4444444444444444" ||
  //             elnik.nik === "5555555555555555" ||
  //             elnik.nik === "6666666666666666" ||
  //             elnik.nik === "7777777777777777" ||
  //             elnik.nik === "8888888888888888" ||
  //             (elnik.nik !== "9999999999999999" &&
  //               countAge(elnik.tgl_lahir) >= 17) ||
  //             elnik.nik === "1901089999999999"
  //         )
  //       )
  //     );
  //     console.log(
  //       "hasil nik tidak wajar: ",
  //       initialData.filter((el) =>
  //         el.data_nik.find(
  //           (elnik) =>
  //             elnik.nik.substring(0, 5) === "12345" ||
  //             elnik.nik.substring(0, 5) === "00000" ||
  //             elnik.nik.substring(11, 16) === "00000" ||
  //             elnik.nik.substring(0, 6) === "010101" ||
  //             elnik.nik.substring(0, 6) === "030303" ||
  //             elnik.nik.substring(0, 6) === "090909" ||
  //             elnik.nik.substring(11, 16) === "66666" ||
  //             elnik.nik.substring(11, 16) === "88888" ||
  //             elnik.nik.substring(11, 16) === "55555" ||
  //             elnik.nik.substring(11, 16) === "11111" ||
  //             ((elnik.nik.substring(0, 5) === "99999" ||
  //               elnik.nik.substring(11, 16) === "99999") &&
  //               elnik.nik !== "9999999999999999") ||
  //             elnik.nik === "0000000000000000" ||
  //             elnik.nik === "1111111111111111" ||
  //             elnik.nik === "2222222222222222" ||
  //             elnik.nik === "3333333333333333" ||
  //             elnik.nik === "4444444444444444" ||
  //             elnik.nik === "5555555555555555" ||
  //             elnik.nik === "6666666666666666" ||
  //             elnik.nik === "7777777777777777" ||
  //             elnik.nik === "8888888888888888" ||
  //             (elnik.nik !== "9999999999999999" &&
  //               countAge(elnik.tgl_lahir) >= 17) ||
  //             elnik.nik === "1901089999999999"
  //         )
  //       )
  //     );

  //     return;
  //   } else if (statusNik === "tidak") {
  //     setKepalaKels(
  //       initialData.filter((item) => item.nik === "9999999999999999")
  //     );
  //     console.log(
  //       "hasil: ",
  //       kepalaKels.filter((item) => item.nik === "9999999999999999")
  //     );
  //     return;
  //   } else {
  //     setKepalaKels(initialData);
  //     return;
  //   }
  // }, [statusNik]);

  const getSearch = async (
    rw,
    rt,
    statusSensus,
    nik999,
    statusNik,
    filterProbability
  ) => {
    let data_nik_999 = [];
    const nik_999 = kepalaKels.find(
      (elNik) => elNik.nik === "9999999999999999"
    );

    try {
      if (
        !rw &&
        !rt &&
        statusSensus === "All" &&
        statusNik === "" &&
        (!Array.isArray(filterProbability) || filterProbability.length === 0)
      ) {
        getAllDataBkkbn();
      } else if (
        !rw &&
        !rt &&
        statusSensus === "All" &&
        statusNik === "ya" &&
        (!Array.isArray(filterProbability) || filterProbability.length === 0)
      ) {
        const selector = {
          user_name: { $eq: metadata.nameProses },
          status_sensus: { $ne: "Delete" },
          status_draft: { $ne: "1" },
        };
        const query = await dataBkkbn.local.find({ selector });
        const newDocs = [];
        query.docs.forEach((item) => {
          if (item.status_sensus !== "Delete" && item.status_draft === "2") {
            newDocs.push(item);
          }
        });
        const filteredDocs = newDocs.filter((doc) =>
          doc.data_nik.some(
            (elnik) =>
              elnik.nik.substring(0, 5) === "12345" ||
              elnik.nik.substring(0, 5) === "00000" ||
              elnik.nik.substring(11, 16) === "00000" ||
              elnik.nik.substring(0, 6) === "010101" ||
              elnik.nik.substring(0, 6) === "030303" ||
              elnik.nik.substring(0, 6) === "090909" ||
              elnik.nik.substring(11, 16) === "66666" ||
              elnik.nik.substring(11, 16) === "88888" ||
              elnik.nik.substring(11, 16) === "55555" ||
              elnik.nik.substring(11, 16) === "11111" ||
              ((elnik.nik.substring(0, 5) === "99999" ||
                elnik.nik.substring(11, 16) === "99999") &&
                elnik.nik !== "9999999999999999") ||
              elnik.nik === "0000000000000000" ||
              elnik.nik === "1111111111111111" ||
              elnik.nik === "2222222222222222" ||
              elnik.nik === "3333333333333333" ||
              elnik.nik === "4444444444444444" ||
              elnik.nik === "5555555555555555" ||
              elnik.nik === "6666666666666666" ||
              elnik.nik === "7777777777777777" ||
              elnik.nik === "8888888888888888" ||
              // elnik.nik === "9999999999999999" ||
              // (elnik.nik !== "9999999999999999" &&
              //   countAge(elnik.tgl_lahir) >= 17) ||
              elnik.nik === "1901089999999999"
          )
        );
        setDataBkkbnDocs(filteredDocs);
      } else if (
        !rw &&
        !rt &&
        statusSensus === "All" &&
        statusNik === "tidak" &&
        (!Array.isArray(filterProbability) || filterProbability.length === 0)
      ) {
        const selector = {
          user_name: { $eq: metadata.nameProses },
          status_sensus: { $ne: "Delete" },
          status_draft: { $ne: "1" },
        };
        const query = await dataBkkbn.local.find({ selector });
        const newDocs = [];
        query.docs.forEach((item) => {
          if (item.status_sensus !== "Delete" && item.status_draft === "2") {
            newDocs.push(item);
          }
        });
        const filteredDocs = newDocs.filter((doc) =>
          doc.data_nik.some((elnik) => elnik.nik === "9999999999999999")
        );
        setDataBkkbnDocs(filteredDocs);
      } else {
        let selector;
        if (rw && statusSensus === "All") {
          if (rt) {
            selector = {
              user_name: { $eq: metadata.nameProses },
              id_rw: rw,
              id_rt: rt,
            };
          } else {
            selector = {
              user_name: { $eq: metadata.nameProses },
              id_rw: rw,
            };
          }
        } else if (
          rw &&
          statusSensus !== "All" &&
          statusSensus !== "Belum Dimutakhirkan"
        ) {
          if (rt) {
            selector = {
              user_name: { $eq: metadata.nameProses },
              id_rw: rw,
              id_rt: rt,
              status_sensus: statusSensus,
            };
          } else {
            selector = {
              user_name: { $eq: metadata.nameProses },
              id_rw: rw,
              status_sensus: statusSensus,
            };
          }
        } else if (rw && statusSensus === "Belum Dimutakhirkan") {
          if (rt) {
            selector = {
              user_name: { $eq: metadata.nameProses },
              id_rw: rw,
              id_rt: rt,
              sts_keluarga: null,
            };
          } else {
            selector = {
              user_name: { $eq: metadata.nameProses },
              id_rw: rw,
              sts_keluarga: null,
            };
          }
        } else if (!rw && !rt && statusSensus !== "All") {
          if (statusSensus === "Belum Dimutakhirkan") {
            selector = {
              user_name: { $eq: metadata.nameProses },
              sts_keluarga: null,
            };
          } else if (opr === "true" && localRw !== "false") {
            if (statusSensus === "Belum Dimutakhirkan") {
              selector = {
                user_name: { $eq: metadata.nameProses },
                sts_keluarga: null,
                id_rw: localRw,
              };
            } else {
              selector = {
                user_name: { $eq: metadata.nameProses },
                id_rw: localRw,
                status_sensus: statusSensus,
              };
            }
          } else {
            if (statusSensus === "Belum Dimutakhirkan") {
              selector = {
                user_name: { $eq: metadata.nameProses },
                sts_keluarga: null,
              };
            } else {
              selector = {
                user_name: { $eq: metadata.nameProses },
                status_sensus: statusSensus,
              };
            }
          }
          if (
            Array.isArray(filterProbability) &&
            filterProbability.length > 0
          ) {
            selector = {
              ...selector,
              flag_retrieve: { $in: filterProbability },
            };
          }
          // console.log("siniiiiiiii 2");
        } else if (filterProbability) {
          selector = {
            user_name: { $eq: metadata.name },
            flag_retrieve: { $in: filterProbability },
          };
        }

        const query = await dataBkkbn.local.find({
          selector,
        });

        const newDocs = [];
        query.docs.forEach((item) => {
          if (item.status_sensus !== "Delete") {
            if (item.status_draft === "2") {
              newDocs.push(item);
            }
          }
        });

        setDataBkkbnDocs(newDocs);
      }
    } catch (e) {
      console.error("Error:", e);
    }
  };

  if (isFetching) {
    return <AppPageLoading />;
  }

  const handleChange = (e) => {
    if (e.target.name == "id_rw") {
      setRw(e.target.value);
      setRt("");
    }

    if (e.target.name == "id_rt") {
      setRt(e.target.value);
    }

    if (e.target.name == "status_sensus") {
      setStatusSensus(e.target.value);
    }
    if (e.target.name == "statusNik") {
      setStatusNik(e.target.value);
    }
    if (e.target.name === "filterProbability") {
      setFilterProbability(e.target.value);
    }
  };

  const handleChangeNIK999 = (e) => {
    if (e.target.name == "id_rw") {
      setRw(e.target.value);
      setRt("");
    }

    if (e.target.name == "id_rt") {
      setRt(e.target.value);
    }

    if (e.target.name == "nik999") {
      setNik999(e.target.value);
    }
  };

  const DeleteDialog = () => {
    return (
      <div>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Yakin menghapus data ini?"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Setelah dihapus data <b> {forDelete.name} </b> akan hilang dari
              daftar keluarga
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="secondary">
              Batal
            </Button>
            <Button onClick={deleteKel(forDelete.id)} color="primary" autoFocus>
              Ya
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  };

  const handleCloseLock = () => {
    setOpenLock(false);
  };
  const handleCloseAlert = () => {
    setIsOpenAlert(false);
  };
  const handleCloseAlertCadangan = () => {
    setIsOpenAlertCadangan(false);
  };

  const handleClose = () => {
    setOpen(false);
    setOpenTotalTarget(false);
    setDelete("");
  };

  const handleClickDelete = (id, name) => async (e) => {
    if (lock === "true" || lockWilayah === "true") {
      setOpenLock(true);
    } else {
      const data = {
        id: id,
        name: name,
      };

      setDelete(data);
      setOpen(true);
    }
  };

  const onDismiss = () => setVisible(false);

  const handleEdit = (id) => async (e) => {
    //
    // let sts_kel = dataBkkbnDocs.find(el => el.sts_keluarga)
    //
    // if (lock === "true" || lockWilayah === "true") {
    //   setOpenLock(true);
    // } else if ((lockTarget === "true" || totalDataKKAll >= targetkk) && sts_kel === true) {
    //   setOpenTotalTarget(true);
    // } else {
    // }
    const selectedEditData = kepalaKels.find((kepala) => kepala._id === id);

    const dataUtamaBelumUpdate = kepalaKels.filter(
      (kepala) =>
        kepala.flag_retrieve &&
        kepala.flag_retrieve?.toLowerCase() === "utama" &&
        (!kepala.sts_keluarga ||
          kepala.sts_keluarga === null ||
          kepala.sts_keluarga === "")
    );

    if (
      selectedEditData.flag_retrieve &&
      selectedEditData.flag_retrieve.toLowerCase() === "utama"
    ) {
      history.push(`form/edit/${id}`);
    } else if (
      metadata.name.substring(0, 4).toLowerCase() === "prob" &&
      dataUtamaBelumUpdate.length > 0
    ) {
      setIsOpenAlert(true);
      return;
    } else {
      const selectedEditData = kepalaKels.find((kepala) => kepala._id === id);

      if (
        metadata.name.substring(0, 4).toLowerCase() === "prob" &&
        selectedEditData?.flag_retrieve &&
        selectedEditData.flag_retrieve.toLowerCase() === "cadangan"
      ) {
        const allDataCadangan = kepalaKels
          .filter(
            (kepala) =>
              kepala.flag_retrieve &&
              kepala.flag_retrieve.toLowerCase() === "cadangan"
          )
          .sort(
            (a, b) =>
              (a.nomor_urut_cadangan || 0) - (b.nomor_urut_cadangan || 0)
          );
        const editData = selectedEditData.nomor_urut_cadangan;
        let initNumber = 0;
        for (let i = 1; i < editData; i++) {
          const prevDataCadangan = allDataCadangan.find(
            (kepala) => kepala.nomor_urut_cadangan === i
          );

          if (
            prevDataCadangan &&
            (!prevDataCadangan.sts_keluarga ||
              prevDataCadangan.sts_keluarga === null ||
              prevDataCadangan.sts_keluarga === "")
          ) {
            initNumber = i;
            break;
          }
        }

        if (initNumber > 0) {
          setNoUrutBelumMutakhir(initNumber);
          setIsOpenAlertCadangan(true);
          return;
        } else {
          history.push(`form/edit/${id}`);
        }
      } else {
        history.push(`form/edit/${id}`);
      }
    }
  };

  const handleChangeExpanded = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <>
      <Container maxWidth="md" className={classes.container}>
        <Grid container spacing={3}>
          <Grid item xs={12} className={classes.textCenter}>
            <Typography variant="h5" component="h1">
              Daftar Keluarga
            </Typography>
          </Grid>

          {/* menampilkan tottal data */}
          {visible ? (
            <>
              <Grid item xs={6} md={6}>
                <Paper
                  style={{
                    backgroundColor:
                      dataLokal < dataServer ? "#f44336" : "#4caf50",
                    width: "100%",
                    color: "#fff",
                    textAlign: "left",
                    padding: "1.25rem",
                  }}
                  elevation={0}
                >
                  <Typography variant="h6">
                    Data Lokal
                    <Typography variant="h6" style={{ float: "right" }}>
                      {dataLokal || 0}
                    </Typography>
                  </Typography>
                </Paper>
              </Grid>

              <Grid item xs={6} md={6}>
                <Paper
                  style={{
                    backgroundColor:
                      dataServer < dataLokal ? "#f44336" : "#4caf50",
                    width: "100%",
                    color: "#fff",
                    textAlign: "left",
                    padding: "1.25rem",
                  }}
                  elevation={0}
                >
                  <Typography variant="h6">
                    Data Server
                    <Typography variant="h6" style={{ float: "right" }}>
                      {dataServer || 0}
                    </Typography>
                  </Typography>
                </Paper>
              </Grid>
            </>
          ) : (
            <>
              <Grid item xs={6} md={6}>
                <Paper
                  style={{
                    backgroundColor:
                      dataLokal < dataServer ? "#f44336" : "#4caf50",
                    width: "100%",
                    color: "#fff",
                    textAlign: "left",
                    padding: "1.25rem",
                  }}
                  elevation={0}
                >
                  <Typography variant="h6">
                    Data Lokal
                    <Typography variant="h6" style={{ float: "right" }}>
                      {dataLokal}
                    </Typography>
                  </Typography>
                </Paper>
              </Grid>

              <Grid item xs={6} md={6}>
                <Paper
                  style={{
                    backgroundColor:
                      dataServer < dataLokal ? "#f44336" : "#4caf50",
                    width: "100%",
                    color: "#fff",
                    textAlign: "left",
                    padding: "1.25rem",
                  }}
                  elevation={0}
                >
                  <Typography variant="h6">
                    Data Server
                    <Typography variant="h6" style={{ float: "right" }}>
                      {dataServer}
                    </Typography>
                  </Typography>
                </Paper>
              </Grid>
            </>
          )}

          <Grid item xs={12} md={12}>
            <Card>
              <CardContent>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Typography variant="h6">Keluarga Probability</Typography>
                  <Box display="flex" gap={2}>
                    <Box
                      px={2}
                      py={1}
                      bgcolor="#cdcdcd"
                      color="#555"
                      borderRadius={8}
                      fontWeight="bold"
                      style={{ marginRight: 2 }}
                    >
                      Utama: {jumlahKeluargaUtama}
                    </Box>
                    <Box
                      px={2}
                      py={1}
                      bgcolor="#cdcdcd"
                      color="#555"
                      borderRadius={8}
                      fontWeight="bold"
                    >
                      Cadangan: {jumlahKeluargaCadangan}
                    </Box>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>

          {/* <Grid item xs={12}>
                        <Alert color="danger" isOpen={visible}>
                            Silahkan melakukan backup as file dan klik tombol replikasi pada menubar!
                        </Alert>
                    </Grid> */}
          {/* end */}

          <Grid item xs={12} md={4}>
            <FormControl variant="outlined" fullWidth>
              {opr === "true" && localRw !== "false" ? (
                <>
                  <Select
                    id="id_rw"
                    value={rw || ""}
                    onChange={handleChange}
                    name="id_rw"
                    displayEmpty
                  >
                    <MenuItem value="">RW</MenuItem>
                    {metadata.wil_rw.map((rw) => {
                      if (parseInt(rw.id_rw) === parseInt(localRw)) {
                        return (
                          <MenuItem key={rw.id_rw} value={rw.id_rw}>
                            {rw.id_rw_bkkbn} - {rw.nama_rw}
                          </MenuItem>
                        );
                      }
                    })}
                  </Select>
                </>
              ) : (
                <>
                  <Select
                    id="id_rw"
                    value={rw || ""}
                    onChange={handleChange}
                    name="id_rw"
                    displayEmpty
                  >
                    <MenuItem value="">RW</MenuItem>
                    {metadata.wil_rw.map((rw) => (
                      <MenuItem key={rw.id_rw} value={rw.id_rw}>
                        {rw.id_rw_bkkbn} - {rw.nama_rw}
                      </MenuItem>
                    ))}
                  </Select>
                </>
              )}
            </FormControl>
          </Grid>
          <Grid item xs={12} md={4}>
            <FormControl variant="outlined" fullWidth>
              <Select
                id="id_rt"
                value={rt || ""}
                onChange={handleChange}
                name="id_rt"
                displayEmpty
              >
                <MenuItem value="">RT</MenuItem>
                {rw &&
                  // metadata.wil_rt &&
                  metadata.wil_rw
                    .find((Rw) => parseInt(Rw.id_rw) === parseInt(rw))
                    .wil_rt.map((rt) => (
                      <MenuItem key={rt.id_rt} value={rt.id_rt}>
                        {rt.id_rt_bkkbn} - {rt.nama_rt}
                      </MenuItem>
                    ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={4} className={classes.textLeft}>
            <FormControl variant="outlined" fullWidth>
              <Select
                id="status_sensus"
                value={statusSensus || ""}
                name="status_sensus"
                onChange={handleChange}
                displayEmpty
              >
                <MenuItem value="All"> Status </MenuItem>
                <MenuItem value=""> Kosong </MenuItem>
                <MenuItem value="Valid"> Valid </MenuItem>
                <MenuItem value="NotValid"> NotValid </MenuItem>
                <MenuItem value="Anomali"> Anomali </MenuItem>
                <MenuItem value="Anomali Terkonfirmasi">
                  {" "}
                  Anomali Terkonfirmasi{" "}
                </MenuItem>
                <MenuItem value="Received"> Received </MenuItem>
                <MenuItem value="Tersimpan"> Tersimpan </MenuItem>
                <MenuItem value="Belum Dimutakhirkan">
                  {" "}
                  Belum Dimutakhirkan{" "}
                </MenuItem>
                {/* {
                                    resultStatus.map((result) => {
                                        return (<MenuItem value={result} key={result}>
                                            {result}
                                        </MenuItem>)
                                    })
                                } */}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3} lg={6} className={classes.textLeft}>
            <FormControl variant="outlined" fullWidth>
              <Select
                id="statusNik"
                value={statusNik || ""}
                name="statusNik"
                onChange={handleChange}
                displayEmpty
              >
                <MenuItem value=""> NIK </MenuItem>
                <MenuItem value="ya">NIK tidak wajar </MenuItem>
                <MenuItem value="tidak"> NIK 9 16x Semua usia </MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3} lg={6} className={classes.textLeft}>
            <FormControl variant="outlined" fullWidth>
              <Select
                id="filterProbability"
                value={filterProbability || ""}
                name="filterProbability"
                onChange={handleChange}
                displayEmpty
                multiple
                renderValue={(selected) => {
                  if (selected.length === 0) {
                    return <Typography>Probability</Typography>;
                  }

                  return selected.join(", ");
                }}
              >
                <MenuItem disabled value="">
                  Probability{" "}
                </MenuItem>
                <MenuItem value="UTAMA">Keluarga Utama </MenuItem>
                <MenuItem value="CADANGAN">Keluarga Cadangan </MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3} lg={3} className={classes.textLeft}>
            {/* <Button
                            
                            disabled={isDeleting}
                            type="button" color="secondary" variant="contained"
                            size="large"
                            onClick={deleteAll}
                            style={{float: 'right'}}
                        >Hapus Semua</Button> */}

            {/* <IconButton
                            disabled={isDeleting}
                            aria-label="refresh"
                            onClick={renewKel}
                            style={{float: 'right'}}
                        >
                            <AutorenewIcon />
                        </IconButton> */}

            {/* <Button
                            disabled={isDeleting}
                            type="button" color="primary" variant="contained"
                            onClick={renewKel}
                            style={{float: 'right'}}
                        >Resend All</Button> */}

            {/* <IconButton
                            disabled={isDeleting}
                            aria-label="refresh"
                            style={{ float: 'right' }}
                        >
                            {totalData <= 0 ? 0 : totalData}
                        </IconButton> */}
            {/* <div
              style={{
                fontSize: "18px",
                fontWeight: "600",
                marginTop: "15px",
                float: "right",
                position: "fixed"
              }}
            >
              {totalData <= 0 ? 0 : totalData}
            </div> */}
          </Grid>

          <Grid item xs={12}>
            <Divider />
          </Grid>
          {dataRedudan.length <= 0 ? (
            <></>
          ) : (
            <>
              <Grid item xs={12}>
                <Accordion
                  expanded={expanded === "panel1"}
                  onChange={handleChangeExpanded("panel1")}
                  style={{ backgroundColor: "rgba(255,235,238,1)" }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                  >
                    <Typography className={classes.heading}>
                      Redudansi Data
                    </Typography>
                    <Typography className={classes.secondaryHeading}>
                      Terdapat {dataRedudan.length} data NIK yang sama
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Container maxWidth="md" className={classes.container}>
                      <Grid container spacing={3}>
                        <Grid item xs={12}>
                          <List>
                            {/* {console.log(
                              kepalaKels.filter(
                                (el) => el.nik === "1101112204930001"
                              ),
                              "ALL"
                            )}
                            {console.log(
                              dataRedudan.filter(
                                (el) => el.nik === "1101112204930001"
                              ),
                              "FOLTER"
                            )} */}
                            {dataRedudan.map((kepala) => {
                              let trim = kepala._id;
                              let id = trim;
                              // let id = trim.substring(0, 13)
                              return (
                                <ListItem divider key={kepala._id}>
                                  {/* {
                                                                    statusSensus == "valid" &&
                                                                } */}
                                  <ListItemText
                                    primary={kepala.nama_anggotakel}
                                    // secondary={`NIK.${kepala.nik}
                                    // Status Sensus.${kepala.status_sensus}`}
                                    secondary={
                                      <div>
                                        <div>{`NIK:${kepala.nik}`}</div>
                                        <div>{`Status: ${kepala.status_sensus}`}</div>
                                        <div>{`No. Rumah: ${kepala.no_rmh}`}</div>
                                        <div>{`No. Urut Keluarga: ${kepala.no_urutkel}`}</div>
                                        <div>
                                          {" "}
                                          Document: {kepala.year_doc},{" "}
                                          {kepala.sts_keluarga ? (
                                            <span style={{ color: "green" }}>
                                              {" "}
                                              OK
                                            </span>
                                          ) : (
                                            <span style={{ color: "red" }}>
                                              {" "}
                                              Belum Dimutakhirkan{" "}
                                            </span>
                                          )}
                                          {kepala.sts_keluarga ? (
                                            <i>
                                              ,{" "}
                                              {
                                                stsKeluarga.find(
                                                  (el) =>
                                                    el.value ===
                                                    kepala.sts_keluarga
                                                ).label
                                              }{" "}
                                            </i>
                                          ) : (
                                            ""
                                          )}{" "}
                                          {(kepala.cfm === 1 ||
                                            kepala.cfm === true) && (
                                            <span
                                              style={{
                                                backgroundColor: "#ff4040ff",
                                                color: "white",
                                                borderRadius: "8px",
                                                padding: "4px 8px",
                                                fontSize: "11px",
                                                marginLeft: "5px",
                                                fontWeight: "bold",
                                                display: "inline-flex",
                                                alignItems: "center",
                                                verticalAlign: "middle",
                                                height: "16px",
                                                lineHeight: "1",
                                                position: "relative",
                                                top: "-1px",
                                              }}
                                            >
                                              CFM
                                            </span>
                                          )}
                                        </div>
                                      </div>
                                    }
                                  />
                                  <ListItemSecondaryAction>
                                    <IconButton
                                      disabled={isDeleting}
                                      //component={Link} to={`form/edit/${id}`}
                                      onClick={handleEdit(id)}
                                      edge="end"
                                      aria-label="edit"
                                    >
                                      <EditIcon />
                                    </IconButton>
                                    <IconButton
                                      disabled={isDeleting}
                                      edge="end"
                                      aria-label="delete"
                                      onClick={handleClickDelete(
                                        kepala._id,
                                        kepala.nama_anggotakel
                                      )}
                                      //onClick={() => alert('Tidak tersedia untuk saat ini')}
                                    >
                                      <DeleteIcon />
                                    </IconButton>
                                  </ListItemSecondaryAction>
                                </ListItem>
                              );
                            })}
                          </List>
                        </Grid>
                      </Grid>
                    </Container>
                  </AccordionDetails>
                </Accordion>
              </Grid>

              <Grid item xs={12}>
                <Divider />
              </Grid>
            </>
          )}

          {}
          {kepalaKels.length <= 0 && (
            <Grid item xs={12} className={classes.textCenter}>
              <Typography>Data tidak ditemukan!</Typography>
            </Grid>
          )}

          <Grid item xs={12}>
            <List>
              {kepalaKels.map((kepala, index) => {
                let no = index + 1;
                let trim = kepala._id;
                let id = trim;

                // Check if NIK is 16 times 9

                const isNikSixteenNines = kepala.nik === "9999999999999999";

                const listItemStyle = {
                  backgroundColor:
                    kepala.status_sensus === "Anomali"
                      ? "rgba(255,235,238,1)"
                      : kepala.niknormal === false
                      ? "rgb(253,221,230)"
                      : "inherit",
                };

                return (
                  <ListItem style={listItemStyle} divider key={kepala._id}>
                    <ListItemText
                      primary={
                        <>
                          {no + ". " + kepala.nama_anggotakel}
                          {kepala.flag_retrieve &&
                            kepala.flag_retrieve === "UTAMA" && (
                              <span
                                style={{
                                  backgroundColor: "#4caf50",
                                  color: "black",
                                  borderRadius: "50%",
                                  padding: "4px 4px",
                                  fontSize: "11px",
                                  marginLeft: "5px",
                                  fontWeight: "bold",
                                  border: "1px solid ",
                                  borderColor: "#000000ff",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  verticalAlign: "middle",
                                  height: "16px",
                                  lineHeight: "1",
                                  position: "relative",
                                  top: "-1px",
                                }}
                              >
                                P
                              </span>
                            )}
                          {kepala.flag_retrieve &&
                            kepala.flag_retrieve.toLowerCase() === "cadangan" &&
                            metadata.name.substring(0, 4).toLowerCase() ===
                              "prob" && (
                              <span
                                style={{
                                  backgroundColor: "#ffc82b",
                                  color: "black",
                                  borderRadius: "12px",
                                  padding: "4px 8px",
                                  fontSize: "11px",
                                  marginLeft: "5px",
                                  fontWeight: "bold",
                                  border: "1px solid ",
                                  borderColor: "#000000ff",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  verticalAlign: "middle",
                                  height: "16px",
                                  lineHeight: "1",
                                  position: "relative",
                                  top: "-1px",
                                  minWidth: "24px",
                                  justifyContent: "center",
                                }}
                              >
                                P {kepala.nomor_urut_cadangan || ""}
                              </span>
                            )}
                          {kepala.flag_retrieve &&
                            kepala.flag_retrieve.toLowerCase() === "cadangan" &&
                            metadata.name.substring(0, 4).toLowerCase() !==
                              "prob" && (
                              <span
                                style={{
                                  backgroundColor: "#ffc82b",
                                  color: "black",
                                  borderRadius: "50%",
                                  padding: "4px 4px",
                                  fontSize: "11px",
                                  marginLeft: "5px",
                                  fontWeight: "bold",
                                  border: "1px solid ",
                                  borderColor: "#000000ff",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  verticalAlign: "middle",
                                  height: "16px",
                                  lineHeight: "1",
                                  position: "relative",
                                  top: "-1px",
                                }}
                              >
                                P
                              </span>
                            )}
                        </>
                      }
                      secondary={
                        <div>
                          <div>{`NIK:${kepala.nik}`}</div>
                          <div>
                            {`Status: ${kepala.status_sensus}`}{" "}
                            {(kepala.status_sensus === "Valid" ||
                              kepala.status_sensus === "Anomali" ||
                              kepala.status_sensus ===
                                "Anomali Terkonfirmasi") &&
                            (kepala.sts_keluarga === "1" ||
                              kepala.sts_keluarga === "5") ? (
                              <CheckCircleIcon
                                style={{
                                  color: "#6169e6",
                                  fontSize: "10px",
                                  marginTop: "-2px",
                                }}
                              />
                            ) : (
                              ""
                            )}
                          </div>
                          <div>{`No. Rumah: ${kepala.no_rmh}`}</div>
                          <div>{`No. Urut Keluarga: ${kepala.no_urutkel}`}</div>
                          <div>
                            {" "}
                            Document: {kepala.year_doc},{" "}
                            {kepala.sts_keluarga ? (
                              <span style={{ color: "green" }}> OK</span>
                            ) : (
                              <span style={{ color: "red" }}>
                                {" "}
                                Belum Dimutakhirkan{" "}
                              </span>
                            )}
                            {kepala.sts_keluarga ? (
                              <i>
                                ,{" "}
                                {
                                  stsKeluarga.find(
                                    (el) => el.value === kepala.sts_keluarga
                                  ).label
                                }{" "}
                              </i>
                            ) : (
                              ""
                            )}
                            {(kepala.cfm === 1 || kepala.cfm === true) && (
                              <span
                                style={{
                                  backgroundColor: "#ff4040ff",
                                  color: "white",
                                  borderRadius: "8px",
                                  padding: "4px 8px",
                                  fontSize: "11px",
                                  marginLeft: "5px",
                                  fontWeight: "bold",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  verticalAlign: "middle",
                                  height: "16px",
                                  lineHeight: "1",
                                  position: "relative",
                                  top: "-1px",
                                }}
                              >
                                CFM
                              </span>
                            )}
                          </div>
                        </div>
                      }
                    />
                    <ListItemSecondaryAction>
                      <IconButton
                        disabled={isDeleting}
                        onClick={handleEdit(id)}
                        edge="end"
                        aria-label="edit"
                      >
                        <EditIcon />
                      </IconButton>
                      {metadata.roleid == 37 ? (
                        <></>
                      ) : (
                        <IconButton
                          disabled={isDeleting}
                          edge="end"
                          aria-label="delete"
                          onClick={(e) => {
                            if (kepala.flag_retrieve || kepala.cfm) {
                              if (
                                kepala.flag_retrieve &&
                                (kepala.flag_retrieve.toLowerCase() ===
                                  "utama" ||
                                  kepala.flag_retrieve.toLowerCase() ===
                                    "cadangan")
                              ) {
                                // console.log(
                                //   "lock - flag_retrieve utama/cadangan"
                                // );
                                e.preventDefault();
                                return false;
                              }

                              if (kepala.cfm === 1 || kepala.cfm === true) {
                                // console.log("lock - cfm true");
                                e.preventDefault();
                                return false;
                              }
                            }
                            handleClickDelete(
                              kepala._id,
                              kepala.nama_anggotakel
                            )(e);
                          }}
                        >
                          {(kepala.flag_retrieve &&
                            (kepala.flag_retrieve.toLowerCase() === "utama" ||
                              kepala.flag_retrieve.toLowerCase() ===
                                "cadangan")) ||
                          kepala.cfm === 1 ||
                          kepala.cfm === true ? (
                            <LockIcon />
                          ) : (
                            // <LockIcon />
                            <DeleteIcon />
                          )}
                        </IconButton>
                      )}

                      {kepala.status_sensus == "" ? (
                        // <IconButton
                        //   disabled={isDeleting}
                        //   edge="end"
                        //   aria-label="refresh"
                        //   onClick={
                        //     lock == "true"
                        //       ? () => alert("Tidak tersedia untuk saat ini")
                        //       : updateKel(kepala._id)
                        //   }
                        // >
                        //   <AutorenewIcon />
                        // </IconButton>
                        <></>
                      ) : (
                        <></>
                      )}
                    </ListItemSecondaryAction>
                  </ListItem>
                );
              })}
            </List>
          </Grid>
        </Grid>

        <DeleteDialog />

        <div>
          <Dialog
            open={isOpenAlert}
            onClose={handleCloseAlert}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{"Pemberitahuan"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Silakan melakukan pendataan untuk keluarga Probability UTAMA
                terlebih dahulu, masih terdapat {jumlahKeluargaUtama} keluarga
                Probability UTAMA belum dimutakhirkan. Silakan menggunakan
                filter pencarian untuk mempermudah menemukan keluarga
                Probability UTAMA
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseAlert} color="primary">
                Tutup
              </Button>
            </DialogActions>
          </Dialog>
        </div>

        <div>
          <Dialog
            open={isOpenAlertCadangan}
            onClose={handleCloseAlertCadangan}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{"Pemberitahuan"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Pendataan keluarga Probability CADANGAN harus berurutan sesuai
                dengan prioritas data CADANGAN. No Urut CADANGAN yang bisa
                dilakukan saat ini adalah nomor {noUrutBelumMutakhir}. No Urut
                CADANGAN (angka) dapat anda lihat setelah huruf pada icon
                PROBABILITY (P)
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseAlertCadangan} color="primary">
                Tutup
              </Button>
            </DialogActions>
          </Dialog>
        </div>

        <div>
          <Dialog
            open={openLock}
            onClose={handleCloseLock}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{"Pemberitahuan"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Periode pendataan untuk wilayah anda telah berakhir
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseLock} color="primary">
                Tutup
              </Button>
            </DialogActions>
          </Dialog>
        </div>

        <div>
          <Dialog
            open={openTotalTarget}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{"Pemberitahuan"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Progres pendataan telah mencapai target
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} color="primary">
                Tutup
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </Container>
    </>
  );
}

export default Home;
